import toPascalCase from '../toPascalCase';

const prefix = `hz-SvgAsset`;

const getAssetClassName = (asset = '', inverse = false, locale = ''): string => {
  if (!asset) {
    return '';
  }

  const pascalAssetName = toPascalCase(asset);

  if (!inverse && !locale) {
    return `${prefix} ${prefix}${pascalAssetName}`;
  }

  if (inverse) {
    // In general, classNames in styles are generated using the basename (ux name), not the key in the Assets.json
    // In order for the inverse icons to work properly, we add the '-inverse' in the key in Assets.json to the name
    //   so that they don't overwrite the asset that is non-inversed in the json file.
    // The 'inverse' in className is represented by '--inverse', so we need to remove the 'inverse' from the asset name as it's redundant
    // Example: tenant-coin-inverse translates to '.hz-SvgAsset.hz-SvgAssetTenantCoin--inverse',
    //   while tenant-coin will become '.hz-SvgAsset.hz-SvgAssetTenantCoin'
    const pascalAssetNameNoInverse = pascalAssetName.replace('Inverse', '');

    if (locale) {
      return `${prefix} ${prefix}${pascalAssetNameNoInverse} ${prefix}${pascalAssetNameNoInverse}--inverse--${locale}`;
    }

    return `${prefix} ${prefix}${pascalAssetNameNoInverse} ${prefix}${pascalAssetNameNoInverse}--inverse`;
  }

  return `${prefix} ${prefix}${pascalAssetName} ${prefix}${pascalAssetName}--${locale}`;
};

export default getAssetClassName;
